<div class="row">
    <div class="col-sm-12" id="service-offering">
        <div class="jumbotron">
            <h1 class="display-4">Boldungu Offering</h1>

                Boldungu  Project is a digital platform which enables children, parents and guardians across the world to
                revise and practice mathematics.  The team at Boldungu believes that
                mathematics can be made easy for everyone, and better at a younger
                age. Children are under
                the parents account which allows parents to closely support their
                children. Quizes are created by Boldungu Automated Examiner (BAE) and marked by the Boldungu Automated Teacher (BAT) both
                online and offline when using mobile devices.



        </div>


        <div class="jumbotron">
            <h1>Boldungu in Action</h1>

                <ol class="list-group list-group-flush">
                    <li class="list-group-item"> <i class ="fa fa-check-square"></i> Parents or guardians should create an account on
                        the platform and then add children/learners to this account</li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i> After your account has been successfully created,
                        you enrol a student, select a country and you will see classes
                        specific to that country.</li>

                    <li class="list-group-item"><i class ="fa fa-check-square"></i>  Select the country where the child is studying  to get questions and quiz
                        customized </li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i>  Tap on the link to create new quiz </li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i>  Select the quiz areas to for the quiz to be
                        generated</li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i> While attempting quizzes, pupils are supposed to
                        pick the right answer for each question</li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i> After attempting all question, pupils will be able
                        to view their result which you can also see</li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i> We recommend that pupils should genreate as may
                        quizes and practice as much as possible before moving to new
                        topics, themes and subtopics</li>
                    <li class="list-group-item"><i class ="fa fa-check-square"></i>  For questions, contact us at
                        boldungu@gmail.com</li>
                </ol>


        </div>

       <app-country-level-syllabus></app-country-level-syllabus>

    </div>
    </div>
